var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/Header.tsx",
  _this = this;
import React, { useContext } from 'react';
import { Responsive } from '@wds/responsive';
import { getClientEnvironmentDetails } from '@sm/utils';
import { VARIANTS } from './variants';
import { Actions } from './components/actions';
import { MobileNav } from './components/mobile-nav';
import { NavBar } from './components/nav-bar';
import { Navigation } from './components/navigation';
import { Title } from './components/title';
import { Logo } from './components/logo';
import useStyles from './useStyles';
import { withHeaderTheme } from './theme';
import HeaderContext from './HeaderContext';
import { StaticContext } from '../../..';
import { useUserContextQueryQuery } from './UserContext.generated';
var getUserContext = function getUserContext(loading, data) {
  var _data$user$preference;
  if (loading || !(data && data.user)) return undefined;
  return {
    userId: data.user.id,
    packageId: data.user.package.id,
    packageName: data.user.package.canonicalName,
    hasLIHPFeature: data.user.features.loggedInHomePage,
    hasSeenLIHPWelcomeModal: data.user.preferences.hasSeenLIHPWelcomeModal,
    homePageEnabled: (_data$user$preference = data.user.preferences.newHomePageEnabled) !== null && _data$user$preference !== void 0 ? _data$user$preference : null
  };
};
var HeaderContent = function HeaderContent(_ref) {
  var _document$location$pa;
  var isEUDC = _ref.isEUDC,
    lang = _ref.lang,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    session = _ref.session;
  var classes = useStyles();
  var _useContext = useContext(StaticContext),
    _useContext$HEADER_EX = _useContext.HEADER_EXP,
    HEADER_EXP = _useContext$HEADER_EX === void 0 ? {} : _useContext$HEADER_EX;
  var headerVariant = VARIANTS[variant];
  var headerTitle = title || headerVariant.title;
  var _useUserContextQueryQ = useUserContextQueryQuery({
      fetchPolicy: 'network-only'
    }),
    loading = _useUserContextQueryQ.loading,
    data = _useUserContextQueryQ.data;
  var _getClientEnvironment = getClientEnvironmentDetails(),
    isNode = _getClientEnvironment.isNode,
    isDesktop = _getClientEnvironment.isDesktop;
  return /*#__PURE__*/React.createElement(HeaderContext.Provider, {
    value: {
      isEUDC: isEUDC,
      lang: lang,
      session: session,
      user: getUserContext(loading, data),
      // first segment of the pathname
      pageName: !isNode ? ((_document$location$pa = document.location.pathname.split('/')) === null || _document$location$pa === void 0 ? void 0 : _document$location$pa[1]) || '' : '',
      pageURL: !isNode ? document.location.pathname : ''
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(NavBar, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(MobileNav, {
    title: headerVariant.title,
    navItems: headerVariant.getMenuItems(HEADER_EXP),
    userMenu: headerVariant.user,
    link: headerVariant.homePage,
    infoMenu: headerVariant.info,
    create: headerVariant.actions.length > 0,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "md",
    defaultMatches: isDesktop,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: classes.navSection,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Logo, {
    link: headerVariant.homePage,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, headerTitle && /*#__PURE__*/React.createElement(Title, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 35
    }
  }, headerTitle), /*#__PURE__*/React.createElement(Navigation, {
    items: headerVariant.getMenuItems(HEADER_EXP),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 19
    }
  })))), /*#__PURE__*/React.createElement("span", {
    className: classes.navSection,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 13
    }
  }, headerVariant.actions && /*#__PURE__*/React.createElement(Actions, {
    items: headerVariant.actions,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, headerVariant.info)), headerVariant.user)))));
};
var HeaderWithTheme = withHeaderTheme(HeaderContent);
var Header = function Header(props) {
  return /*#__PURE__*/React.createElement(HeaderWithTheme, Object.assign({
    theme: "wrench"
  }, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 10
    }
  }));
};
export default Header;
export { Header };
//# sourceMappingURL=Header.js.map